import './MainBlockV2.scss'
import {useEffect} from "react";
import {connect} from "react-redux";
import {getPropsFromState} from "../../../redux/mapStateToProps";
import {GetSliderHome} from "../../../redux/actions";
import MainSliderItem from "./MainSliderItem/MainSliderItem"
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';


function MainBlockV2(props) {
    const {event, sliderHome, staticTexts} = props;
    useEffect(() => {
        props.GetSliderHome('HOME')
    }, [])

    const firstSliderData = event ? event?.map(item => {
        return {
            id: item.id,
            mediaMain: item?.mediaMain,
            title: item?.title,
            description: item?.subTitle,
            badge: item?.type,
            link: `/news/${item?.slug}`
        }
    }) : [];

    const secondSliderData = sliderHome ? sliderHome?.map(item => {
        let mediaMain = item.mediaMain;
        let title = item.title;
        let subTitle = item.subTitle;
        let link = item.link;

        if (item?.blog) {
            mediaMain = item.blog?.mediaMain;
            title = item.blog?.title;
            subTitle = item.blog?.subTitle;
            // link = `/${BLOGS_TYPE_PATHS[item.blog?.type]}/${item.blog?.slug}`
            link = `/news/${item.blog?.slug}`
        }
        return {
            id: item.id,
            mediaMain: mediaMain,
            title: title,
            description: subTitle,
            badge: item?.blog?.type,
            link: link
        }
    }) : [];

    return <div className={'mainSliderBlock-wrapper'}>
        <div className={'slider_wrapper'}>
            <MainSliderItem sliderList={firstSliderData}
                            showBadge={true}/>
        </div>
        <div className={'slider_wrapper'}>
            <MainSliderItem sliderList={secondSliderData}
                            showBadge={true}/>
        </div>
    </div>
}

const mapStateToProps = (state) => {
    return getPropsFromState(state, [
        'staticTexts',
        'requestLoading',
        'event',
        'sliderHome',
        'contacts',
    ])
};
const mapDispatchToProps = {
    GetSliderHome,
};
export default connect(mapStateToProps, mapDispatchToProps)(MainBlockV2);